import i18n from "@/lib/i18n.js";

export const SIDEBAR_LABEL_NAMESPACES = ["definitionsNav", "matrixConfiguration"];

let loadPromise = null;
const listeners = new Set();

export function resolveSidebarLabelLanguage(lng = i18n.resolvedLanguage || i18n.language) {
  return String(lng || "en").split("-")[0];
}

export function hasSidebarLabelNamespaces(lng = i18n.resolvedLanguage || i18n.language) {
  const code = resolveSidebarLabelLanguage(lng);
  return SIDEBAR_LABEL_NAMESPACES.every(
    (ns) => i18n.hasResourceBundle(code, ns) || i18n.hasResourceBundle(lng, ns),
  );
}

export function ensureSidebarLabelNamespaces() {
  if (hasSidebarLabelNamespaces()) {
    listeners.forEach((fn) => fn());
    return Promise.resolve();
  }
  if (!loadPromise) {
    loadPromise = i18n.loadNamespaces(SIDEBAR_LABEL_NAMESPACES).then(() => {
      listeners.forEach((fn) => fn());
    }).finally(() => {
      loadPromise = null;
    });
  }
  return loadPromise;
}

export function subscribeSidebarLabelNamespaces(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
